<template>

    <div class="carrello-row-3__codice-sconto codice-sconto mb-0" v-if="discount == 0">
        <div class="codice-sconto__dropdown">
            <div class="codice-sconto__row-1 cursor-pointer" @click="showDiscountBox = !showDiscountBox">
                Possiedi un codice sconto?
                <img class="ease" src="/images/svg/roeno-37.svg" alt="icona" :class="{'rotate' : showDiscountBox}" />
            </div>

            <div class="codice-sconto__row-2" v-if="showDiscountBox">

                <div class="full-input pt-1">
                    <div class="full-input__field-gr mt-2">
                        <input type="text" @focus="validation.discount.state = false" v-model="discountCode" :placeholder="$root.translateString('discount_code')" >
                        <label class="full-input__after-input focused">{{$root.translateString('code')}}</label>
                        <div class="invalid-feedback" :class="{'d-block' : validation.discount.state}">{{validation.discount.message}}</div>
                    </div>
                </div>

                <div class="form-submit mt-3 pt-1 mb-2">
                    <div class="brand-btn">
                        <a class="dark smaller" href="javascript:void(0)" @click="applyDiscount" type="button">
                            <span>{{$root.translateString('apply_code')}}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        props: ['discount', 'lang'],
        data() {
            return {
                discountCode: '',
                showDiscountBox: false,
                validation: {
                    discount: {
                        state: null,
                        message: ''
                    }
                }
            }
        },
        mounted() {
        },
        methods: {
            applyDiscount()
            {
                if(this.discountCode == "") {
                    this.validation.discount.state = true;
                    if(this.lang == 'it') {
                        this.validation.discount.message = 'Devi inserire un codice valido';
                    }else{
                        this.validation.discount.message = 'Your code is invalid';
                    }
                    return
                }

                axios.post('/api/cart/discount', {
                    code: this.discountCode
                })
                    .then(response => {

                        if(!response.data.success) {
                            if(this.lang == "it") {
                                this.validation.discount.message = 'Il codice inserito non è valido';
                            }else{
                                this.validation.discount.message = 'Your code is invalid';
                            }
                            this.validation.discount.state = true;
                        }else{
                            this.$eventHub.$emit('discount.applied');
                        }

                    })
            },
        },
        beforeDestroy() {

        },
    }
</script>
